import { createReducer, on } from '@ngrx/store';
import { IBankAccountTypesState, initialUIState } from './bank-account-types.state';
import {
  toggleBankAccountTypesLoading,
  loadBankAccountTypesSuccess,
  loadBankAccountTypesFailure,
} from './bank-account-types.actions';

export const bankAccountTypesReducer = createReducer(
  initialUIState,
  on(toggleBankAccountTypesLoading, (state, { isLoading }) => ({
    ...state,
    isLoading,
  })),
  on(loadBankAccountTypesSuccess, (state, { bankAccountTypes }) => ({
    ...state,
    list: bankAccountTypes,
    isLoading: false,
  })),
  on(loadBankAccountTypesFailure, (state) => ({
    ...state,
    isLoading: false,
  }))
);